/**
 * Plan Action Types
 *
 * Enum of action types for backend plan mutations.
 * These correspond to the action parameter in the plan update API.
 */
export enum PlanActionType {
  AddCourse = 'add_course',
  AddCourses = 'add_courses',
  RemoveCourse = 'remove_course',
  ReorderCourse = 'reorder_course',
  AddCourseAtPosition = 'add_course_at_position',
  SetActive = 'set_active',
  UpdateName = 'update_name',
  UpdatePrograms = 'update_programs',
  ReorderPrograms = 'reorder_programs',
  UpdateCreditTarget = 'update_credit_target',
  UpdateCurrentTerm = 'update_current_term',
  // Placeholder persistence (#205)
  MoveCourse = 'move_course',
  AddPlaceholder = 'add_placeholder',
  UpdatePlaceholder = 'update_placeholder',
  RemovePlaceholder = 'remove_placeholder',
  ConvertPlaceholder = 'convert_placeholder',
}
